import { Toast } from '@statsbomb/kitbag-components';
import { useAtomValue, useSetAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
import { closeToastAtom, toastDataAtom } from '@/atoms/toast';

export const GenericToast = () => {
  const { t } = useTranslation(['toast', 'general']);
  const toastData = useAtomValue(toastDataAtom);
  const { toastName, type, content, entityName, translationOptions, isOpen } = toastData;
  const closeToast = useSetAtom(closeToastAtom);

  const description = t(`${toastName}.${type}.description`, {
    ns: 'toast',
    tryAgain: t('tryAgain', { ns: 'general' }),
    entityName: `${entityName}`,
    interpolation: { escapeValue: false },
    ...translationOptions,
  });

  return (
    <Toast isOpen={isOpen} onClose={closeToast} type={type} testId={`${toastName}-${type}`}>
      {description}
      {content}
    </Toast>
  );
};
